export default {
    enterpriseTypeOption: [
        { id: 1, name: "物业公司", roleId: "100000000000000000000001" },
        { id: 2, name: "维保公司", roleId: "200000000000000000000001" },
        // { id: 3, name: "设备厂商" },
        { id: 4, name: "监管单位", roleId: "000000000000000000000003" },
        { id: 5, name: "党群单位", roleId: "100000000000000000000002" },
    ],
    telecomCodeList: [
        { value: 10086, label: "移动" },
        { value: 10010, label: "联通" },
        { value: 10000, label: "电信" },
        // { value: 10099, label: "广电" },
        // { value: 1, label: "聚合" },
    ],
     //社区楼盘类型
    communityTypeList: [
        { value: 0, label: "其他" },
        { value: 1, label: "住宅" },
        { value: 2, label: "写字楼" },
        { value: 3, label: "商场" },
        { value: 4, label: "工业园区" },
        { value: 5, label: "别墅" },
        { value: 6, label: "学校" },
        { value: 7, label: "医院" },
    ],
}


// WEBPACK FOOTER //
// ./src/utils/globalvar.js